// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"EZlmS3H_h1JU","item":"_3YOS3G1Uj_YF","item_selected":"_3eKCDO-qqirl","item__icon":"_3KNmpqDrIZnM"};